export const CLEAR_ERROR = 'CLEAR_ERROR'
export const FETCH_ERROR = 'FETCH_ERROR'
